import { useMemo } from 'react';

interface UseListHeightOptions {
  isSmallScreen: boolean;
  isListView?: boolean;
}

/**
 * Custom hook to calculate list height based on screen size, view mode, and analysis type.
 *
 * This hook centralizes the complex list height logic that was previously duplicated
 * across multiple components.
 */
export function useListHeight({
  isSmallScreen,
  isListView = true,
}: UseListHeightOptions): string {
  return useMemo(() => {
    return isSmallScreen && !isListView ? 'auto' : '100%';
  }, [isSmallScreen, isListView]);
}
